/* eslint-disable @typescript-eslint/no-explicit-any */
import Axios, { AxiosInstance, AxiosResponse } from 'axios';
import { Constants } from '@portal/config/env';
import { getCookie, setCookie } from '@portal/services/cookie';

const headersDefault = {
  'Content-Type': 'application/json',
  mode: 'cors',
  'arco-brand-domain': Constants.brandDomain,
  Authorization: `Bearer ${getCookie('portal-token') || getCookie('lms-auth-token')}`,
};

export const setAuthorizationHeader = (token: string): void => {
  axiosInstance.defaults.headers.Authorization = `Bearer ${token}`;
  newAxiosInstanceV1.defaults.headers.Authorization = `Bearer ${token}`;
  newAxiosInstanceV2.defaults.headers.Authorization = `Bearer ${token}`;
  journeyAxiosInstance.defaults.headers.Authorization = `Bearer ${token}`;
  bffContentLibraryAxiosInstance.defaults.headers.Authorization = `Bearer ${token}`;
};

export const setBrandDomainHeader = (brandDomain: string): void => {
  axiosInstance.defaults.headers['arco-brand-domain'] = brandDomain;
  newAxiosInstanceV1.defaults.headers['arco-brand-domain'] = brandDomain;
  newAxiosInstanceV2.defaults.headers['arco-brand-domain'] = brandDomain;
  journeyAxiosInstance.defaults.headers['arco-brand-domain'] = brandDomain;
  bffContentLibraryAxiosInstance.defaults.headers['arco-brand-domain'] = brandDomain;
};

export const createAxiosInstance = (baseURL: string): AxiosInstance => {
  const instance = Axios.create({
    baseURL,
    headers: headersDefault,
  });

  instance.interceptors.response.use(
    (response: AxiosResponse) => response,
    async (error) => {
      if (error.response && error.response.status === 401) {
        window.location.replace(`${Constants.portalUrl}/errors/unauthorized`);

        return;
      }

      if (error.response) {
        return Promise.reject(error);
      }
    }
  );

  return instance;
};

export const axiosInstance = createAxiosInstance(Constants.backOld || '');
export const newAxiosInstanceV1 = createAxiosInstance(`${Constants.backNew || ''}/v1`);
export const newAxiosInstanceV2 = createAxiosInstance(`${Constants.backNew || ''}/v2`);
export const journeyAxiosInstance = createAxiosInstance(`${Constants.backJourney || ''}/v1`);
export const bffContentLibraryAxiosInstance = createAxiosInstance(`${Constants.backBffContentLib || ''}/v1`);

export const getInstance = (options?: {
  api?: 'old' | 'new' | 'journey' | 'bffContentLibrary';
  version?: 'v1' | 'v2';
}): AxiosInstance => {
  if (options?.api === 'new') {
    switch (options?.version) {
      case 'v1':
        return newAxiosInstanceV1;
      case 'v2':
        return newAxiosInstanceV2;
      default:
        return newAxiosInstanceV1;
    }
  }

  if (options?.api === 'journey') {
    return journeyAxiosInstance;
  }

  if (options?.api === 'bffContentLibrary') {
    return bffContentLibraryAxiosInstance;
  }

  return axiosInstance;
};
